import React, { useState } from 'react';
import Update from '../Update';
import ContractFinancial from 'models/ContractFinancialModel';
import Media from '../Media';

import {
  Card,
  Stack,
  Fade,
  Divider,
  Checkbox,
  Typography,
  CardHeader,
  CardActionArea,
  Button,
  Tooltip,
  IconButton,
  Chip,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import PaymentRoundedIcon from '@mui/icons-material/PaymentRounded';
import { AvatarPopover, NewSpeedDial, CardHeaderTitle } from 'components';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';
import { fCurrency } from 'helpers/formatNumber';

export default function Model({ model, delay, direction, checked, handleSelect, selectOnClick, refetch, color }) {
  const { isAuthenticated, userInfo } = useSelector((state) => state.auth);

  const getEmployerName = (model) => {
    if (model?.company?.title) {
      return `${model?.company?.title}`;
    }
    if (model?.employer?.firstname && model?.employer?.lastname) {
      return `${model?.employer?.firstname} ${model?.employer?.lastname}`;
    }
    if (model?.employer?.firstname) {
      return `${model?.employer?.firstname}`;
    }
    if (model?.employer?.lastname) {
      return `${model?.employer?.lastname}`;
    } else {
      return undefined;
    }
  };

  const getTotal = (model) => {
    if (model?.operation_type?.id === '1') {
      return model?.total_service;
    }
    if (model?.operation_type?.id === '2') {
      return model?.total_tonnage;
    }
    if (model?.operation_type?.id === '5') {
      return model?.total_cubic_meter;
    } else {
      return undefined;
    }
  };

  const chips = [
    { id: '1', name: 'workshop', title: model?.workshop?.title },
    { id: '2', name: 'employer', title: getEmployerName(model) },
    { id: '3', name: 'category', title: model?.category?.title },
    { id: '4', name: 'number', title: model?.number },
    { id: '5', name: 'cost', title: `مبلغ : ${fCurrency(model?.cost)}`, width: 140 },
    { id: '6', name: 'operationType', title: `برآورد : ${fCurrency(model?.forecast_amount)}` },
    // { id: '7', name: 'forecastAmount', title: `ثبت : ${getTotal(model)}` },
    { id: '8', name: 'totalService', title: `پیشرفت : ${Math.round(Number(model?.progress_done_cost)) + ' %'}` },
  ];

  const [updateOpen, setUpdateOpen] = useState(false);
  const canUpdate =
    isAuthenticated &&
    hasRequiredRole(['superadmin', 'companyCeo', 'companyOperator', 'companyFinancial'], userInfo?.roles);
  const handleRowClick = () => (canUpdate && !selectOnClick ? setUpdateOpen(true) : handleSelect());

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 100, enter: delay * 120, exit: delay * 140 }}>
        <Card
          sx={{
            position: 'relative',
            // bgcolor: checked && 'action.disabledBackground',
            bgcolor: checked ? 'primary.light' : color ? 'action.disabledOpacity' : 'action.focus',
          }}
        >
          <Stack direction="row" alignItems="center" columnGap={0.5}>
            <Stack flexShrink={0} alignItems="center" justifyContent="center" sx={{ pl: 0.5 }}>
              <Checkbox size="small" checked={checked} onChange={handleSelect} />
            </Stack>
            <CardActionArea onClick={handleRowClick} sx={{ flex: 1, minWidth: 0 }}>
              <CardHeader
                sx={{ px: 0.5, py: 1 }}
                title={<CardHeaderTitle maxWidth="100%" chipWidth="120px" title={model?.title} chips={chips} />}
              />
            </CardActionArea>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              columnGap={0.5}
              flexShrink={0}
              sx={{ pr: 1, pl: 0.5, py: 0.5, zIndex: 1 }}
            >
              <NewSpeedDial>
                {isAuthenticated &&
                  hasRequiredRole(
                    ['superadmin', 'companyCeo', 'companyOperator', 'companyFinancial'],
                    userInfo?.roles
                  ) && (
                    <>
                      <Update ids={model.id} title={<FormattedMessage id="update" />} refetch={refetch} />
                      <ContractFinancial isPopup ids={model.id} title={<FormattedMessage id="financials" />}>
                        <Tooltip>
                          <IconButton sx={{ bgcolor: 'warning.lighter' }} size="small" color="warning">
                            <PaymentRoundedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </ContractFinancial>
                    </>
                  )}
              </NewSpeedDial>
            </Stack>
          </Stack>
        </Card>
      </Fade>
      {updateOpen && (
        <Update
          open
          ids={model.id}
          refetch={refetch}
          title={<FormattedMessage id="update" />}
          onClose={() => setUpdateOpen(false)}
        />
      )}
      <Divider variant="middle" />
    </>
  );
}
